import { EMPTY_STRING } from 'commons/constants/immutable';
import _get from 'lodash/get';
import { EHomePageViewType, IHomePageV4View, ISegmentBasedUser, ITObject } from './constants';

export const getArrayKeys = (obj: Partial<IHomePageV4View>): string[] => {
	const keys: string[] = [];

	const traverse = (currentObj: any, path: string) => {
		Object.keys(currentObj).forEach((key) => {
			const newPath = path ? `${path}.${key}` : key;

			// Check if the current value is an array
			if (Array.isArray(currentObj[key as keyof IHomePageV4View])) {
				keys.push(newPath);
			} else if (
				typeof currentObj[key as keyof IHomePageV4View] === 'object' &&
				currentObj[key as keyof IHomePageV4View] !== null
			) {
				traverse(currentObj[key as keyof IHomePageV4View] as IHomePageV4View, newPath);
			}
		});
	};

	traverse(obj, EMPTY_STRING);
	return keys;
};

export const convert1dListInto2d = (viewList: string[]): string[][] => {
	const newViewList: string[][] = [];
	for (let i = 0; i < viewList.length; i += 1) {
		newViewList.push(viewList[i].split(','));
	}
	return newViewList;
};

export const createNonSegmentActualHomePageV4Obj = (homePageView: ITObject<string[][]>): Partial<IHomePageV4View> => {
	const result: Partial<IHomePageV4View> = {} as IHomePageV4View;
	Object.keys(homePageView).forEach((key) => {
		const keyParts: string[] = key.split('.');
		let current: Partial<IHomePageV4View> = result;

		keyParts.forEach((part, index) => {
			if (!current[part]) {
				// If it's the last part, assign the default value
				current[part] = index === keyParts.length - 1 ? homePageView[key] : {};
			}
			current = current[part];
		});
	});
	return result;
};

export const createSegmentActualHomePageV4Obj = (homePageView: ITObject<string[][]>): ISegmentBasedUser[] => {
	const result: ISegmentBasedUser[] = [];
	Object.keys(homePageView).forEach((key) => {
		const keyParts = key.split('.');
		result.push({
			segment: keyParts[keyParts.length - 1],
			view: homePageView[key]
		});
	});
	return result;
};

export const createCompleteObject = (
	segmentBasedView: ITObject<string[][]>,
	nonSegmentBasedView: ITObject<string[][]>
): IHomePageV4View => {
	const result: IHomePageV4View = {
		...createNonSegmentActualHomePageV4Obj(nonSegmentBasedView),
		segmentBasedUser: createSegmentActualHomePageV4Obj(segmentBasedView)
	};
	return result;
};

export const getSegmentKeys = (obj: ISegmentBasedUser[]): string[] => {
	const keys: string[] = obj.map((element) => `${EHomePageViewType.SEGMENT_BASED_USER}.${element.segment}`);
	return keys;
};

export const getExceptSegmentViewValueByKeys = (keys: string[], obj: Partial<IHomePageV4View>) => {
	const viewBasedOnLinearKeys: ITObject<string[][]> = {};
	for (let i = 0; i < keys.length; i += 1) {
		viewBasedOnLinearKeys[keys[i] as keyof ITObject<string[][]>] = _get(obj, keys[i]);
	}
	return viewBasedOnLinearKeys;
};

export const getSegmentViewValueByKeys = (keys: string[], obj: ISegmentBasedUser[]): ITObject<string[][]> => {
	const viewBasedOnLinearKeys: ITObject<string[][]> = {};
	for (let i = 0; i < keys.length; i += 1) {
		for (let j = 0; j < obj.length; j += 1) {
			if (obj[j].segment === keys[i].split('.')[1]) {
				viewBasedOnLinearKeys[keys[i] as keyof ITObject<string[][]>] = obj[j].view;
			}
		}
	}
	return viewBasedOnLinearKeys;
};
